export default __webpack_public_path__ + "static/media/Kevin Nogilny.e8460ab7.jpg";